import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { ChatComponent, SplitPaneComponent } from '@components';
import { SplitPaneVerticalComponent, HistoryComponent } from '@components';

interface ComplianceReviewDraft {
  framework: string;
  dataClassification: string;
  evidenceNotes: string;
}

@Component({
  selector: 'app-compliance',
  templateUrl: './compliance.page.html',
  styleUrls: ['./compliance.page.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    ChatComponent,
    HistoryComponent,
    SplitPaneComponent,
    SplitPaneVerticalComponent
],
})
export class CompliancePage {
  public complianceSuggestions: any[] = [
    { icon: 'bi bi-shield-check', prompt: 'What policies need attention?' },
    { icon: 'bi bi-calendar-event', prompt: 'Upcoming deadlines' },
    { icon: 'bi bi-folder-check', prompt: 'Evidence required for SOC2' },
  ];

  public complianceContext: any = {
    page: 'compliance',
    purpose: 'Guide compliance tasks, policies and evidence collection',
    frameworks: ['SOC2'],
    policies: [],
    tasks: [],
    deadlines: [],
    outputs: ['Tasks by framework', 'Upcoming deadlines', 'Evidence checklist']
  };

  public validatingCompliance = false;
  public complianceError = '';
  public complianceSuccess = '';
  public hasValidated = false;
  public complianceDraft: ComplianceReviewDraft = {
    framework: '',
    dataClassification: '',
    evidenceNotes: '',
  };

  public readonly frameworkOptions = ['SOC2', 'ISO 27001', 'GDPR', 'HIPAA'];
  public readonly dataClassificationOptions = ['Public', 'Internal', 'Confidential', 'Restricted'];

  constructor() {}

  public async runComplianceCheck(): Promise<void> {
    this.complianceError = '';
    this.complianceSuccess = '';
    this.hasValidated = false;

    if (!this.complianceDraft.framework.trim()) {
      this.complianceError = 'Select a compliance framework before running the check.';
      return;
    }
    if (!this.complianceDraft.dataClassification.trim()) {
      this.complianceError = 'Select a data classification before running the check.';
      return;
    }

    this.validatingCompliance = true;
    try {
      await new Promise((resolve) => setTimeout(resolve, 700));
      this.hasValidated = true;
      this.complianceSuccess = 'Compliance review completed for the selected controls.';
    } finally {
      this.validatingCompliance = false;
    }
  }
} 